import React from "react";
import { Button, DropdownButton } from "../../components/Button";
import { ArrowBackIcon } from "../../icons/ArrowBackIcon";


const SaveFilterButton = ({ selected, saveFilter, saveChanges, hasChanges }) => {
    const actions = {
        save: () => saveChanges(),
        saveAs: () => saveFilter()
    }

    return(
        selected
            ? <DropdownButton
                items={[
                    { key: "save", title: "Save changes" },
                    { key: "saveAs", title: "Save as..." },
                ]}
                onMenuClick={({ key }) => actions[key]()}
            >
                <Button link>
                    <span>Save filter</span>
                    <ArrowBackIcon size={16} rotate={270} />
                </Button>
            </DropdownButton>
            : <Button link onClick={() => actions.saveAs()}>Save filter</Button>
    )
};

export { SaveFilterButton };